const DEFAULT_MESSAGE = "We're updating our systems. Please check back shortly.";

interface MaintenanceOverlayProps {
    message: string;
}

export default function MaintenanceOverlay({ message }: MaintenanceOverlayProps) {
    return (
        <div
            role="alertdialog"
            aria-modal="true"
            aria-labelledby="maintenance-title"
            className="fixed inset-0 z-1500 flex items-center justify-center bg-black/70"
        >
            <div className="w-[90%] max-w-120 rounded-xl bg-popover p-10 text-center shadow-lg ring-1 ring-foreground/10">
                <h2
                    id="maintenance-title"
                    className="mb-2 text-xl font-bold text-foreground"
                >
                    Down for maintenance
                </h2>
                <p className="text-sm text-muted-foreground">
                    {message || DEFAULT_MESSAGE}
                </p>
            </div>
        </div>
    );
}
